module.exports = __webpack_public_path__ + "b506a66a688dd0df4b191f1ff1611c45.mp3";


//////////////////
// WEBPACK FOOTER
// ./sounds/ding.mp3
// module id = 13
// module chunks = 0